import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import RoutePath from '../utils/routes/RoutePath';
import { toast } from 'react-toastify';
import Constants from '../utils/Constants';
import AddWard from '../component/AddWard';
import { isCharacterReg } from '../utils/validation';

class AddVendorWard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: {},
            message: {},
            isLoading: false,
            wardName: '',
            headUserId: 'ALL',
        }
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            this.setState({ isLoading: true })
            this.props?.getVendorWardDetail({ id: this.props.match.params.id }, (response) => {
                const data = response || {}
                const headUserId = data?.response?.headUserId
                this.setState({
                    wardName: data?.response?.wardName,
                    headUserId: headUserId != null && headUserId !== '' ? headUserId : 'ALL',
                    isLoading: false
                })
            }, false)
        }
    }

    updateWard = () => {
        const callback = (res) => {
            this.setState({ isLoading: false })
            if (res?.response_code === 0) {
                toast.success(params.id ? Constants.UPDATED_SUCCESSFULLY : Constants.ADDED_SUCCESSFULLY)
                this.props.history.push(RoutePath.VENDOR_WARD)
            } else {
                toast.error(res?.response_message || res?.response?.data?.response_message)
            }
        }
        const isEdit = !!this.props.match.params.id
        let params = {
            wardName: this.state?.wardName,
            id: this.props.match.params.id,
        }
        const headUserId = this.state?.headUserId
        const isUnassigned = !headUserId || headUserId === 'ALL' || headUserId === '' || headUserId == null

        if (!params?.wardName || params?.wardName.trim().length === 0) {
            this.setState({ error: { wardName: true }, message: { wardName: "Please Enter Ward Name" } })
            return
        }
        if (!isCharacterReg(params?.wardName)) {
            this.setState({ error: { wardName: true }, message: { wardName: Constants.NAME_REGX } })
            return
        }
        if (!isEdit && isUnassigned) {
            this.setState({ error: { headUserId: true }, message: { headUserId: Constants.PLEASE_SELECT_WARD_NURSE } })
            return
        }

        if (isEdit) {
            if (isUnassigned) {
                params.unassignHead = true
                params.headUserId = null
            } else {
                params.headUserId = headUserId
            }
        } else {
            params.headUserId = headUserId
        }

        this.setState({ isLoading: true, error: {}, message: {} })
        if (params.id) {
            this.props.updateVendorWard(params, callback, false)
        } else {
            delete params.id
            this.props.createVendorWard(params, callback, false)
        }
    }

    handleWardName = (e) => {
        let wardName = e.target.value;
        if (!wardName || wardName.length === 0) {
            this.setState({ wardName: wardName, error: { wardName: true }, message: { wardName: Constants.PLEASE_ENTER_THE_NAME } })
        } else {
            this.setState({ wardName: wardName, error: { wardName: false }, message: { wardName: ' ' } })
        }
        this.setState({ wardName: wardName })
    }

    handleHeadNurse = (e) => {
        let headUserId = e.target.value;
        if (!headUserId || headUserId === 'ALL') {
            // Create still requires a nurse; edit allows unassign
            const isEdit = !!this.props.match.params.id
            this.setState({
                headUserId,
                error: { headUserId: !isEdit },
                message: { headUserId: isEdit ? ' ' : Constants.PLEASE_SELECT_WARD_NURSE },
            })
        } else {
            this.setState({ headUserId, error: { headUserId: false }, message: { headUserId: ' ' } })
        }
    }

    render() {
        const { isLoading } = this.state
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <AddWard
                            value={this.state}
                            handleSubmit={() => this.updateWard()}
                            handleWardName={(e) => { this.handleWardName(e) }}
                            handleHeadNurse={(e) => { this.handleHeadNurse(e) }}
                            message={this.state.message}
                            error={this.state.error}
                            isEdit={this.props.match.params.id}
                        />
                    </div>
                </div>
                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {}
};
export default withRouter(connect(mapStateToProps, {
    createVendorWard: Actions.createVendorWard,
    updateVendorWard: Actions.updateVendorWard,
    getVendorWardDetail: Actions.getVendorWardDetail
})(AddVendorWard));
